<div class="content">
    <mat-grid-list cols="1" rowHeight="fit" gutterSize="15px">
        <mat-grid-tile>
            <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name="right-panel" >
            </ngx-spinner>
            <mat-card appearance="outlined" class="card-data">
                    <mat-card-header>
                        <mat-card-title>
                            <div class="main-title"> 
                                <span>Vincular Produto</span>
                                <div fxFlex></div>
                                <button mat-mini-fab  matTooltip="Salvar" (click)="salvar()" [disabled]="disabled"> 
                                    <mat-icon  aria-hidden="false" >check</mat-icon>
                                </button>
                            </div>
                            
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="card-content">
                            <mat-stepper>
                                <mat-step>
                                    <ng-template matStepLabel>Cadastro</ng-template>
                                    <div class="field-vinculo">
                                        <form [formGroup]="formVinculo">
                                            <search-input  entityname="Mktpproducts"  entitydesc="Cadastro de Produtos" [form]="formVinculo" controlname="CODEPRODUCTVAR" placeholder="Cód. Produto" (focusout)="mountgrid()" columnname="CODEPRODUCT">
                                            </search-input>
                                            <mat-form-field appearance="outline" [formGroup]="formVinculo">
                                                <mat-label>Preço</mat-label>
                                                <input #price matInput formControlName="PRICE" placeholder="Preço" type = "text" mask="separator.2"> 
                                                <button   tabindex="-1"  matSuffix mat-icon-button aria-label="Clear" (click)="dynamicServices.getDataFromTable(formVinculo, 'PRICE','Mktpshopeevar',null, null, 'text' );" matTooltip="Buscar do Dados">
                                                    <mat-icon>reply</mat-icon>
                                                </button>
                                                <button  tabindex="-1"  type="button" *ngIf="price.value" matSuffix mat-icon-button aria-label="Clear" (click)="price.value=''">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </mat-form-field>
                                            <mat-form-field appearance="outline" [formGroup]="formVinculo">
                                                <mat-label>Quantidade</mat-label>
                                                <input  matInput formControlName="QUANTITY" placeholder="Quantidade"   #quantity type = "number"> 
                                                <button   tabindex="-1"  matSuffix mat-icon-button aria-label="Clear" (click)="dynamicServices.getDataFromTable(formVinculo, 'QUANTITY','Mktpshopeevar',null, null, 'text' );" matTooltip="Buscar do Dados">
                                                    <mat-icon>reply</mat-icon>
                                                </button>
                                                <button  tabindex="-1"  type="button" *ngIf="quantity.value" matSuffix mat-icon-button aria-label="Clear" (click)="quantity.value=''">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" [formGroup]="formVinculo">
                                                <mat-label>Item Id</mat-label>
                                                <input  matInput formControlName="ITEMID" placeholder="Item Id"   #itemId> 
                                                <button   tabindex="-1"  matSuffix mat-icon-button aria-label="Clear" (click)="dynamicServices.getDataFromTable(formVinculo, 'ITEMID','Mktpshopeevar',null, null, 'text' );" matTooltip="Buscar do Dados">
                                                    <mat-icon>reply</mat-icon>
                                                </button>
                                                <button  tabindex="-1"  type="button" *ngIf="itemId.value" matSuffix mat-icon-button aria-label="Clear" (click)="itemId.value=''">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </mat-form-field>
                                        </form>
                                    </div>
                                </mat-step>
                                <mat-step>
                                    <ng-template matStepLabel>Variações do Produto</ng-template>
                                    <div *ngIf="showVariationOptions" class="variation-grid">
                                        <div *ngIf="variations.length == 0">
                                            <div class="no-data">
                                                <strong>Não existem variações cadastradas.</strong>
                                            </div>
                                        </div>
                                        <form [formGroup]="formVinculo">
                                            <div *ngFor="let item of variations;let i=index" class="lines">
                                                <mat-grid-list cols="3" rowHeight="fit" gutterSize="15px">
                                                    <mat-grid-tile colspan="1">
                                                        {{item.name}}
                                                    </mat-grid-tile>
                                                    <mat-grid-tile colspan="2">
                                                        <mat-form-field class="field-options" >
                                                            <mat-label>{{item.name}}</mat-label>
                                                            <mat-select (selectionChange)="changeSelection($event)" [formControlName]="item.name" [id]="item.name">
                                                            <mat-option *ngFor="let option of item.option_list; let index=index" [value]="index">
                                                                {{option.option}}
                                                            </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </mat-grid-tile>
                                                </mat-grid-list>
                                            </div>
                                        </form>
                                    </div>
                                </mat-step>
                            </mat-stepper>
                        </div>
                    </mat-card-content>
            </mat-card>
        </mat-grid-tile>
    </mat-grid-list>
    
</div>
